export enum RangeEnum {
  H8 = '8H',
  D1 = '1D',
  D5 = '5D',
  W1 = '1W',
  M1 = '1M',
  M3 = '3M',
  M6 = '6M',
  Y1 = '1Y',
  Y2 = '2Y',
  Y3 = '3Y',
  ALL = 'ALL',
  CUSTOM = 'CUSTOM',
}
